const domainCompanyMap: Record<string, string> = {
    'www.empresariopulpero.com': 'medicor',
    'empresariopulpero.com': 'medicor',
    'transformatutienda.co': 'transforma-tu-tienda',
    'www.transformatutienda.co': 'transforma-tu-tienda',
    // Agregar más reglas de redirección aquí de ser necesario
};

export default domainCompanyMap;
